module.exports = __webpack_public_path__ + "img/1528696589.6db1b434.jpg";